"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _TextArea["default"];
  }
});

var _TextArea = _interopRequireDefault(require("./TextArea"));


//////////////////
// WEBPACK FOOTER
// ../~/semantic-ui-react/dist/commonjs/addons/TextArea/index.js
// module id = 2170
// module chunks = 1